import { Component, inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { fromToolbar, ToolbarActions } from 'shared/classroom/toolbar/data-access';
import { map } from "rxjs/operators";
import { ToolbarButtonComponent } from '../toolbar-button.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'pcp-slide-sync-toolbar-button-ellipse',
    templateUrl: './toolbar-button-ellipse.component.html',
    styleUrls: ['./toolbar-button-ellipse.component.scss'],
    imports: [ToolbarButtonComponent, AsyncPipe]
})
export class ToolbarButtonEllipseComponent {

    @Input() icon = 'trip_origin';
    @Input() fontSet = '';

    private readonly store: Store = inject(Store);

    readonly isDrawingEnabled$ = this.store.select(
        fromToolbar.isDrawingEnabled
    );

    readonly isActivated$ = this.store.select(
        fromToolbar.selectActivatedDrawingTool
    ).pipe(
        map(activatedTool => activatedTool === 'ellipse')
    );

    public toggle() {
        this.store.dispatch(
            ToolbarActions.toggleDrawingTool({ toolName: 'ellipse' })
        );
    }
}

